import React from 'react';

const rebrandingInfoIcon = () => (
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="#161719"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="symbol-info">
            <g id="fill">
                <path d="M7.34049 7.16699V12.5003H8.67383L8.67383 7.16699H7.34049Z" />
                <path d="M7.00716 5.50032C7.00716 4.94804 7.45488 4.50033 8.00716 4.50033C8.55945 4.50033 9.00716 4.94804 9.00716 5.50033C9.00716 6.05261 8.55945 6.50033 8.00716 6.50033C7.45488 6.50033 7.00716 6.05261 7.00716 5.50032Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.3405 8.50033C15.3405 12.5504 12.0572 15.8337 8.00716 15.8337C3.95707 15.8337 0.673828 12.5504 0.673828 8.50033C0.673828 4.45024 3.95707 1.16699 8.00716 1.16699C12.0572 1.16699 15.3405 4.45024 15.3405 8.50033ZM14.0072 8.50033C14.0072 11.814 11.3209 14.5003 8.00716 14.5003C4.69345 14.5003 2.00716 11.814 2.00716 8.50033C2.00716 5.18662 4.69345 2.50033 8.00716 2.50033C11.3209 2.50033 14.0072 5.18662 14.0072 8.50033Z"
                />
            </g>
        </g>
    </svg>
);

export default rebrandingInfoIcon;
